import React, { useState, useEffect, useRef } from 'react';
import { Picker } from 'antd-mobile';
import { pureList } from '@/services/saas/dept';
import { rooms } from '@/services/saas/room';
import { getUser } from '@/utils';
import _ from 'lodash';
import './index.scss';

const CloseIcon = (props) => (
  <svg className={props.className} viewBox="64 64 896 896" focusable="false"  data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>
)

const DefaultData = [
  {
    value:'-1',
    label: '无',
  }
]

const SearchInput = (props) => {

  const { value, onChange, onInputChange } = props;

  let inputRef = null;

  const handleClick = () => {
    inputRef.focus()
  }

  const changeInput = useRef(_.debounce((inputValue)=>{
    onInputChange(inputValue);
  }, 500)).current;

  const handleChange = (target) => {
    const inputValue = target.value;
    onChange(inputValue);
    changeInput(inputValue);
  }
  const handleClear = () => {
    onChange('');
    changeInput('');
  }

  return (
    <div className={'searchInput'} >
      <div onClick={handleClick}>
        <input value={value} onChange={e => handleChange(e.target)} ref={(e) => inputRef = e } placeholder="点击模糊查询机构">
        </input>
      </div>
      <span onClick={handleClear}>
        {value &&  <CloseIcon className={'search-input-close'}></CloseIcon>}
      </span>
    </div>
  )
}

const PickerTempLate = (props) => {
    const { value, title, className, onClick } = props;
    return (
      <span className={className} onClick={onClick}>
          <input className="picker-input" readOnly placeholder={title} value={value}>
          </input> 
          <i aria-label="图标: calendar" className="picker-icon">
            <svg viewBox="0 0 1024 1024" focusable="false"data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path></svg>
          </i>
      </span>
    )
  }
  
  const OrgPicker = (props) => {
  
    const { onChange } = props;
    
    const [ value, setValue ] = useState([]);
    
    const [ data, setData ] = useState([]);
  
    const [ selected, setSelected ] = useState({});

    const [ inputValue, setInputValue ] = useState(undefined);
  
    const getInfo = async (deptName) => {
      const { deptId: deptDataAuth } = getUser() || {};
      const resp = await pureList({ size: -1, deptDataAuth, deptName });
      let depts = [];
      if (resp && resp.success && resp.data.length > 0) {
        depts = resp.data.map(item => ({
          value: item.id,
          label: item.deptName,
          children: []
        }));
        const dept = depts[0];
        const children = await getRooms(dept.value);
        depts[0].children = [...children];
        setValue([dept.value]);
      }
      setData(depts);
    }
  
    const getRooms = async (deptId) => {
      const resp = await rooms({ deptId });
      if (resp && resp.success){
        const defaultOption = { label: '请选择', value: '' };
        return [
          defaultOption,
          ...resp.data.map(item => ({
            value: item.id,
            label: item.name
          }))
        ]
      } 
      return [];
    }
  
    const pickerChange = async (value) => {
      const [ deptId ] = value;
      const temp = data.filter(item => item.value === deptId);
      if (temp.length > 0) {
        temp[0].children = await getRooms(deptId);
        await setData([...data]);
      }
      setValue(value);
    }
  
    const getRoomObj = (value) => {
      let room = {};
      const tempId = value[value.length -1];
      const [ dId, roomId ] = value;
      if (roomId) {
        const [ dept ] = data.filter(item => item.value === dId);
        room = dept.children.filter(item => item.value === tempId)[0];
      }
      return room;
  
    }
  
    const handleOk = (val) => {
      if (val && val !== -1) {
        const room = getRoomObj(val);
        setSelected(room);
        if(onChange) onChange(room.value);
      }
    }

    const handleSearch = (value) => {
      getInfo(value);
    }
  
    useEffect(() => {
      getInfo();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
    return (
      <>
        <Picker 
          className="down-select"
          value={value}
          onOk={handleOk}
          onPickerChange={pickerChange}
          cols={data.length > 0? 2:1}
          data={data.length > 0? data: DefaultData}
          title={
            <SearchInput 
              value={inputValue} 
              onChange={setInputValue} 
              onInputChange={handleSearch}/>
          }
        >
          <PickerTempLate value={selected.label || ''} title="请选择" className="filter-time-picker" ></PickerTempLate>
        </Picker>
      </>
    )
  }

  export default OrgPicker;